import { object, string } from 'yup';

import { TFunction } from 'react-i18next';

export const validationSchema = (t: TFunction<'translation', undefined>) =>
	object().shape({
		email: string().required(t('Email is required')).email(t('Please enter a valid email')),
		full_name: string().required(t('Full name is required')).min(2, t('Full name must be at least 2 characters')),
	});
